'use client';

import { itemsPerPage } from '@module/constants/pagenation';
import { useBoardListQuery } from '@module/queries/customer/customerQueryHooks';
import { convertISOToDottedShortDateString } from '@module/utils/date/convertDateFormat';
import BasePagenation from '@pc/components/pagenation/BasePagenation';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import TableItemsTotalNumber from '@pc/components/table/TableItemsTotalNumber';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@pc/components/ui/table';
import { keepPreviousData } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

function CustomerNoticeListContainer() {
  const router = useRouter();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const currentPageFirstOffset = (currentPage - 1) * itemsPerPage;

  const { data: noticeList } = useBoardListQuery(
    {
      page: 'notice',
      offset: currentPageFirstOffset,
      limit: itemsPerPage,
    },
    { placeholderData: keepPreviousData },
  );

  const isListEmpty = !noticeList?.page.total;

  return (
    <div className='h-[800px]'>
      <TableItemsTotalNumber className='mb-4' count={noticeList?.page.total ?? 0} />
      <Table>
        <colgroup>
          <col width='80px' />
          <col width='*' />
          <col width='128px' />
        </colgroup>

        <TableHeader>
          <TableRow className='h-[50px]'>
            <TableHead className='h-12 text-center'>{'번호'}</TableHead>
            <TableHead>{'제목'}</TableHead>
            <TableHead>{'작성일'}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {noticeList?.list.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell className='text-center'>
                {row.importantYN === 'Y' ? (
                  <span className='whitespace-nowrap rounded-lg bg-colorBg_notice_badge px-2 py-1 text-[#ef312a] text-[14px]'>
                    {'필독'}
                  </span>
                ) : (
                  <span className='text-colorFg18'>{noticeList.page.total - currentPageFirstOffset - idx}</span>
                )}
              </TableCell>
              <TableCell>
                <button
                  type='button'
                  className='w-full text-left text-colorFg19'
                  onClick={() => router.push(`/customer/notice/${row.idx}`)}
                >
                  {row.subject}
                </button>
              </TableCell>
              <TableCell className='text-colorFg18'>{convertISOToDottedShortDateString(row.insertDateTime)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isListEmpty && <NotFoundDisplay text={'검색결과가 없습니다.'} />}

      <BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={noticeList?.page} />
    </div>
  );
}

export default CustomerNoticeListContainer;
